export default {
  SET_SUBSCRIPTION_ID: (state, id) => {
    state.subscriptionId = id;
  },

  SET_CURRENT_CALL: (state, call) => {
    state.currentCall = call;
  },

  SET_LOADING: (state, loading) => {
    state.loading = { ...state.loading, ...loading };
  },
};
